import React from "react";
import { Row, Col } from "shards-react";

const Table40 = (props) => {
  return (
    <Row>
      <Col md="12" style={{ padding: "15px" }}>
        <h3>
          กรุณาเพิ่ม ข้อมูลต่างๆ ในตัวชี้วัดที่ 7 :
          สัดส่วนการขนส่งสินค้าทางรางและสัดส่วนการขนส่งสินค้าทางน้ำ/
          สัดส่วนปริมาณการขนส่งสินค้าทางรางต่อปริมาณการขนส่งสินค้าทั้งหมดภายในประเทศ/
          สัดส่วนปริมาณการขนส่งสินค้าทางน้ำต่อปริมาณการขนส่งสินค้าทั้งหมดภายในประเทศ
        </h3>
      </Col>
    </Row>
  );
};

export default Table40;
